export default "__VITE_ASSET__90542044__"